export default __webpack_public_path__ + "0c9c751d8ded5b4fd4bdc9044c862abb.png";